import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { API } from "../config/api-config";
import { CommonService } from "../service/common";
import { m } from "@angular/core/src/render3";
import QRCode from "qrcode";
import * as moment from "moment";
import * as _ from "lodash";

declare var alertify: any;
declare var $: any;
@Component({
  templateUrl: "./settingCourse.html",
  styleUrls: ["./settingCourse.component.css"],
})
export class SettingCourse implements OnInit {
  constructor(
    private router: Router,
    private http: HttpService,
    private common: CommonService
  ) {}

  private data: any = [];
  private imagePath: string = "";
  public pageData: object = {};
  public page = { pageNumber: 1 };
  public searchValue: any = {
    search: "",
    recommend: "",
    active: "1",
    type: "",
    startTimeBegin: "",
    startTimeEnd: "",
  };
  ngOnInit(): void {
    this.getPath();
    this.getType();
    var self = this;

    $("#startTime")
      .datepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd",
        todayBtn: 1,
        autoclose: true,
      })
      .on("changeDate", function (ev) {
        $("#endTime").datepicker("setStartDate", $("#startTime").val());
        self.searchValue.startTimeBegin = $(this).val();
      });
    $("#endTime")
      .datepicker({
        language: "zh-CN",
        format: "yyyy-mm-dd",
        todayBtn: 1,
        autoclose: true,
        // startDate: this.common.dateFormat(new Date(), "yyyy-MM-dd hh:mm"),
      })
      .on("changeDate", function (ev) {
        $("#startTime").datepicker("setEndDate", $("#endTime").val());
        self.searchValue.startTimeEnd = $(this).val();
      });
  }

  private getPath(): void {
    this.http.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
      this.getData();
    });
  }

  public getData(isSearch = false) {
    let data = { ...this.page };
    data.pageNumber--;

    if (isSearch) {
      console.log(this.searchValue);
      data = { ...data, ...this.searchValue };
    }
    if (data["startTimeBegin"]) {
      data["startTimeBegin"] = moment(data["startTimeBegin"]).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    }
    if (data["startTimeEnd"]) {
      data["startTimeEnd"] = moment(data["startTimeEnd"])
        .hours(23)
        .minute(59)
        .second(59)
        .format("YYYY-MM-DD HH:mm:ss");
    }
    console.log(data);
    this.http.getData(API.course, data).then((res) => {
      this.data = res.data.content;
      this.pageData = res.data;
      delete this.pageData["content"];
      for (let i = 0; i < this.data.length; i++) {
        QRCode.toDataURL(this.data[i].qrCode).then((url) => {
          this.data[i].qrCodeImg = url;
        });
        if (!/^http/.test(this.data[i].imageEn)) {
          this.data[i].imageEn = this.imagePath + this.data[i].imageEn;
        }
        if (!/^http/.test(this.data[i].imageTc)) {
          this.data[i].imageTc = this.imagePath + this.data[i].imageTc;
        }
        if (!/^http/.test(this.data[i].detailImageTc)) {
          this.data[i].detailImageTc =
            this.imagePath + this.data[i].detailImageTc;
        }
        if (!/^http/.test(this.data[i].detailImageEn)) {
          this.data[i].detailImageEn =
            this.imagePath + this.data[i].detailImageEn;
        }
      }
    });
  }

  private editProduct(id: number) {
    this.router.navigate(["index/settingCourse", id]);
  }
  //
  private deleteProduct(id: number, item: any): void {
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        item["deleting"] = true;
        _self.http.deleteData(API.course + "/" + id).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            item["deleting"] = false;
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }

  public pageChange(e: any) {
    // console.log(e);
    this.page = e;
    this.getData(true);
  }

  public importIng = false;
  public importCourse() {
    this.importIng = true;
    alertify.prompt(
      "Import",
      "count",
      "",
      (e, str) => {
        if (e) {
          this.http.getData(API.courseImport, { count: str }).then((res) => {
            if (res.status.code == 0) {
              alertify.success("成功更新" + res.data + "筆");
              this.getData();
              this.importIng = false;
            } else {
              alertify.error(res.status.message);
            }
          });
        } else {
        }
      },
      () => {
        this.importIng = false;
      }
    );
  }

  public searchData() {
    this.page.pageNumber = 1;
    this.getData(true);
  }

  public typeList: any = [];

  private getType() {
    this.http.getData(API.courseType).then((res) => {
      this.typeList = res.data;
    });
  }

  public checkBoxClick(e) {
    if (e.selected) {
      e.selected = false;
    } else {
      e.selected = true;
    }
  }

  public deleteAllSelect() {
    let ids = _.map(this.data, (item) => {
      if (item.selected) return item.id;
    });
    ids = _.compact(ids);
    console.log(ids);
    let _self = this;
    alertify.confirm(
      "删除",
      "確定要刪除嗎？",
      function () {
        _self.http.postData(API.courseDeleteAll, { id: ids }).then((res) => {
          if (res.status.code == 0) {
            alertify.success(res.status.message);
            _self.getData();
          } else {
            alertify.error(res.status.message);
          }
        });
      },
      function () {}
    );
  }

  public exporting = false;
  public exportCourse() {
    this.exporting = true;
    let data = { ...this.searchValue };
    data.startTimeBegin &&
      (data.startTimeBegin = data.startTimeBegin + " 00:00:00");
    data.startTimeEnd && (data.startTimeEnd = data.startTimeEnd + " 23:59:59");
    console.log(data);
    this.http.download(API.exportCourses, data).then((res) => {
      console.log(res);
      if (res.status.code == 0) {
        alertify.success(res.status.message);
      } else {
        alertify.error(res.status.message);
      }
      this.exporting = false;
    });
  }
}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/activity/settingCourse.component.ts